.breadcrumbs {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: Hanken Grotesk;
    font-weight: 500;
    font-size: 14px;
    line-height: 19.6px;
    white-space: nowrap;
}

.crumb {
    color: #133971;
}

.crumbLink {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.crumbCurrent {
    color: #9198a6;
}

.divider {
    color: #133971;
    flex-shrink: 0;
    display: block;
}

.dividerCurrent {
    color: #9198a6;
}
